import React from 'react';
import { Icon } from './Icon.js';
export const IconSortDownFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m8,6.5h-4c-.477,0-.905.265-1.118.691-.213.426-.168.927.118,1.309l2,2.667c.238.318.603.5,1,.5s.762-.183,1-.5l2-2.667c.286-.381.331-.883.118-1.309-.213-.426-.641-.691-1.118-.691Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconSortDownFill12.js.map